import Quiz1 from './components/Quiz1.svelte';
import Quiz2 from './components/Quiz2.svelte';
import Subscription from './components/Subscription.svelte';
import Navigation from './components/Navigation.svelte';

const quiz1 = document.querySelector('#quiz1');
const quiz2 = document.querySelector('#quiz2');
const subscription = document.querySelector('#subscription');
const navigation = document.querySelector('#menu');

if (navigation) {
  new Navigation({
    target: navigation,
    intro: true,
  });
}

if (quiz1) {
  new Quiz1({
    target: quiz1,
  });
}

if (quiz2) {
  new Quiz2({
    target: quiz2,
  });
}

if (subscription) {
  new Subscription({
    target: subscription,
  });
}
